var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplayLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 136.47 33.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:10px;font-family:Poppins-SemiBold, Poppins;font-weight:600;}.cls-1,.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 13.62,
    y1: 496.26,
    x2: -5.49,
    y2: 476.68,
    gradientTransform: "translate(0 -466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4998d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4a99d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#42baeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#41c7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#56c9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5bcae8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 27.85,
    y1: 483.19,
    x2: -0.39,
    y2: 483.19,
    gradientTransform: "translate(0 -466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#febd11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#faa51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 7.64,
    y1: 490.07,
    x2: -18.28,
    y2: 463.52,
    gradientTransform: "translate(0 -466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef4049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31e63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -12.3,
    y1: 496.84,
    x2: -0.73,
    y2: 484.99,
    gradientTransform: "translate(0 -466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4bba71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5ebd6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66be69"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "googlepaly-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(44.48 8.54)"
  }, "Coming soon on "), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.07,19.24a4.85,4.85,0,0,0-5,4.81,4.78,4.78,0,0,0,5,4.79,4.91,4.91,0,0,0,5-4.79A4.85,4.85,0,0,0,69.07,19.24Zm0,7.8a2.9,2.9,0,1,1,2.8-2.9A2.88,2.88,0,0,1,69.07,27Zm-10.9-7.8a4.85,4.85,0,0,0-5,4.81,4.78,4.78,0,0,0,5,4.79,4.91,4.91,0,0,0,5-4.79A4.79,4.79,0,0,0,58.17,19.24Zm0,7.8a2.9,2.9,0,1,1,2.8-2.9A2.88,2.88,0,0,1,58.17,27Zm-12.9-6.3v2.1h5a3.9,3.9,0,0,1-1.1,2.6,5.23,5.23,0,0,1-3.9,1.5,5.5,5.5,0,1,1,0-11,5.14,5.14,0,0,1,3.8,1.5l1.5-1.5a7.37,7.37,0,0,0-5.3-2.1,7.69,7.69,0,0,0-7.8,7.5,7.75,7.75,0,0,0,7.8,7.5,7.16,7.16,0,0,0,5.4-2.1,6.74,6.74,0,0,0,1.8-4.8,5.28,5.28,0,0,0-.1-1.3h-7.1Zm52.9,1.6a4.63,4.63,0,0,0-9,1.71,4.75,4.75,0,0,0,4.9,4.79,5,5,0,0,0,4.1-2.1l-1.7-1.1a2.81,2.81,0,0,1-2.4,1.3,2.51,2.51,0,0,1-2.4-1.5l6.6-2.7Zm-6.8,1.6a2.63,2.63,0,0,1,2.6-2.8,1.78,1.78,0,0,1,1.8,1ZM86,28.64h2.2V14.34H86Zm-3.6-8.3h0a3.75,3.75,0,0,0-2.7-1.1,4.85,4.85,0,0,0,0,9.7,3.34,3.34,0,0,0,2.6-1.1h.1v.7c0,1.9-1,2.8-2.6,2.8a2.7,2.7,0,0,1-2.5-1.7l-1.9.7a4.69,4.69,0,0,0,4.4,2.9c2.6,0,4.7-1.5,4.7-5V19.55h-2.1ZM79.87,27a2.82,2.82,0,0,1-2.8-2.9,2.91,2.91,0,0,1,2.8-3,2.77,2.77,0,0,1,2.7,3A2.8,2.8,0,0,1,79.87,27Zm28.5-12.7h-5.2v14.2h2.2v-5.4h3a4.59,4.59,0,0,0,4.8-4.4A4.59,4.59,0,0,0,108.37,14.34Zm0,6.9h-3.1v-4.9h3.1a2.55,2.55,0,0,1,2.6,2.4A2.5,2.5,0,0,1,108.37,21.24Zm13.5-2.1a4.15,4.15,0,0,0-3.9,2.2l1.9.8a2,2,0,0,1,2-1c1.1,0,2.3.7,2.3,1.8v.2a5,5,0,0,0-2.3-.6c-2.1,0-4.2,1.1-4.2,3.2,0,1.9,1.7,3.1,3.6,3.1a3,3,0,0,0,2.8-1.4h.1v1.11h2.1V23.14C126.27,20.64,124.37,19.14,121.87,19.14Zm-.3,7.9c-.7,0-1.7-.3-1.7-1.2,0-1.1,1.2-1.5,2.3-1.5a3.68,3.68,0,0,1,2,.5A2.68,2.68,0,0,1,121.57,27Zm12.4-7.5-2.5,6.2h-.1l-2.6-6.2h-2.3l3.9,8.6-2.2,4.8h2.3l6-13.4Zm-19.6,9.1h2.2V14.34h-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.5,3A2.35,2.35,0,0,0,0,4.64v25.2a2.33,2.33,0,0,0,.5,1.6l.1.11L15.1,17.44v-.3L.5,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.9,22l-4.8-4.7V17l4.8-4.7.1.1,5.7,3.2c1.6.9,1.6,2.4,0,3.3L20,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20,22l-4.9-4.8L.5,31.44a2.08,2.08,0,0,0,2.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M20,12.44,3,2.94A2.06,2.06,0,0,0,.5,3L15,17.24Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayLight);
export default __webpack_public_path__ + "static/media/googleplay-light.15c315c693bb0eb5160cae9c6fb8a44f.svg";
export { ForwardRef as ReactComponent };